import script from "./NavbarSec.vue?vue&type=script&setup=true&lang=js"
export * from "./NavbarSec.vue?vue&type=script&setup=true&lang=js"

import "./NavbarSec.vue?vue&type=style&index=0&id=5f88a714&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f88a714"]])

export default __exports__